import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css";
import "./styles/common.scss";
import toastRegistry from './views/message.js';
Vue.use(toastRegistry);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
